import React from 'react';
import { Tooltip as ReactTooltip } from 'react-tooltip';

export const COLLECTION_CLIENTS_TABLE_TOOLTIP_ID = 'collection-clients-table-tooltip';

export const collectionClientsTooltipProps = (content: string) => ({
  'data-tooltip-id': COLLECTION_CLIENTS_TABLE_TOOLTIP_ID,
  'data-tooltip-content': content,
});

export const NO_BALANCE_OWED_TOGGLE_TOOLTIP =
  'No balance owed — this client has no past-due invoice with an amount due.';

export const bucketDisabledToggleTooltip = (bucket: string | null) =>
  `The ${bucket ?? 'client’s'} bucket is turned off in Collection Configuration.`;

export const RESIDENTIAL_SUPPRESSED_TOGGLE_TOOLTIP =
  'Home services clients are excluded from emailing in Configuration.';

export const NO_USABLE_EMAIL_TOGGLE_TOOLTIP = 'No company email on file. Add a contact email in Servman.';

export const CollectionClientsTableTooltip: React.FC = () => (
  <ReactTooltip id={COLLECTION_CLIENTS_TABLE_TOOLTIP_ID} style={{ zIndex: 1500, maxWidth: 320 }} />
);
